// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeInfoAggregatorDto
 */
export interface IEmployeeInfoAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoAggregatorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoAggregatorDto
     */
    last_name?: string;
}

/**
 * Check if a given object implements the IEmployeeInfoAggregatorDto interface.
 */
export function instanceOfIEmployeeInfoAggregatorDto(value: object): value is IEmployeeInfoAggregatorDto {
    return true;
}

export function IEmployeeInfoAggregatorDtoFromJSON(json: any): IEmployeeInfoAggregatorDto {
    return IEmployeeInfoAggregatorDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function IEmployeeInfoAggregatorDtoToJSON(json: any): IEmployeeInfoAggregatorDto {
    return IEmployeeInfoAggregatorDtoToJSONTyped(json, false);
}

export function IEmployeeInfoAggregatorDtoToJSONTyped(value?: IEmployeeInfoAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

